module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bMjdWz/tc-custom/9780226778693.jpg?1731166637834",
      "alt": "This image is the cover for the book Geometrical Vectors, Chicago Lectures in Physics"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Geometrical Vectors, Chicago Lectures in Physics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Every advanced undergraduate and graduate student of physics must master the concepts of vectors and vector analysis. Yet most books cover this topic by merely repeating the introductory-level treatment based on a limited algebraic or analytic view of the subject."), _c('br'), _c('br'), _c('i', [_vm._v("Geometrical Vectors")]), _vm._v(" introduces a more sophisticated approach, which not only brings together many loose ends of the traditional treatment, but also leads directly into the practical use of vectors in general curvilinear coordinates by carefully separating those relationships which are topologically invariant from those which are not. Based on the essentially geometric nature of the subject, this approach builds consistently on students' prior knowledge and geometrical intuition."), _c('br'), _c('br'), _vm._v(" Written in an informal and personal style, "), _c('i', [_vm._v("Geometrical Vectors")]), _vm._v(" provides a handy guide for any student of vector analysis. Clear, carefully constructed line drawings illustrate key points in the text, and problem sets as well as physical examples are provided."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gabriel Weinreich\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Please fill in author biography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0